import Breadcrumb from './index.vue'

export default Breadcrumb
